<div class="form-row">
  <div class="col-sm-4 d-flex flex-row">
    <button class="btn btn-sm btn-outline-primary col-sm-5 mr-5 rounded-pill margin-right-0 btn-tab" type="button"
      (click)="fileInput.click()">
      {{buttonTitle}}
    </button>
    <div class="col-sm-10 mr-5 margin-top-7">Max 2MB file size is allowed.</div>
    <input #fileInput type="file" accept="{{imageExtensions}}" (change)="onFileChange($event)"  style="height: 0px;">
  </div>
</div>
<div class="form-row" *ngIf="invalidFileType">
  <p class="text-danger pl-3">Invalid image type</p>
</div>
<div class="form-row" *ngIf="uploadStatus">
  <p class="text-success pl-3">{{uploadStatus}}</p>
</div>
<br>

<app-modal #attachmentmodal [modalConfig]="modalConfig" >
  <div class="form-row d-flex">
    <div class="col-md-7">
      <image-cropper
        [imageChangedEvent]="imgChangeEvt"
        [maintainAspectRatio]="true"
        [aspectRatio]="4 / 4"
        [resizeToWidth]="256"
        format="png"
        (imageCropped)="cropImg($event)"
        (imageLoaded)="imgLoad()"
        (cropperReady)="initCropper()"
        (loadImageFailed)="imgFailed()">
      </image-cropper>
    </div>
  </div>
</app-modal>

